import { restClient } from '../config/restClient'

const endpoint = memberProfileId => `/api/company/v2/member_profiles/${memberProfileId}`

export const patchMemberProfile = async (memberProfileId, data) => {
  const response = await restClient(endpoint(memberProfileId), {
    method: 'PATCH',
    data,
  })
  return response.data
}

export const getMemberProfileHiringTeams = async memberProfileId => {
  const response = await restClient(`${endpoint(memberProfileId)}/hiring_teams`, {
    method: 'GET',
  })
  return response.data
}
